import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  styled,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { get, post, put } from "../../../utils/api";
import InputField from "../../../Components/Masters/InputField";
import SelectField from "../../../Components/Masters/SelectField";
import { validateNumber } from "../../../utils/validateFields";
import { numberError } from "../../../utils/validationMessage";
import Multiline from "../../../Components/Masters/Multiline";
import EditDialog from "../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../Components/Common/MonthYearPicker";
import FileField from "../../../Components/Masters/FileField";
import formatTitleWithOptional from "../OptionalFeild";
import { useUser } from "../../../context/AuthContext";

function AddFireExitingul({
  inputData,
  fetchData,
  id,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const [fuelType, setFuelType] = useState("");

  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    fugitiveEmissionSource: data?.fugitiveEmissionSource || "",
    typeOfSubstance: data?.typeOfSubstance || "",
    machineryName: data?.machineryName?._id || "",
    quantityReleased: data?.quantityReleased || "",
    uniqueIdOfEquipment: data?.uniqueIdOfEquipment?._id || "",
    fuelType: data?.fuelType || "",
    quantityOfFuelConsumed: data?.quantityOfFuelConsumed || "",
    hoursUsed: data?.hoursUsed || "",
    remarks: data?.remarks || "",
    documents: data?.documents || [],
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  const resetForm = () => {
    setFormData(data === null ? initialState : data);
    setFuelType(data === null ? "" : data?.fuelType);
    setErrors({}); // Reset errors
    console.log("FromValue:", data);
  };
  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    // setErrors({});
    resetForm();
    // setSelectedMonth(data?.monthYear?.month || "");
    // setSelectedYear(data?.monthYear?.year || "");
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };

  const fetchFuelType = async () => {
    await get(`/master/scope1/getByIDMachinery?Id=${formData.machineryType}`)
      .then((response) => {
        console.log("responseForFuelType", response.data.data?.fuelType);
        setFuelType(response.data.data?.fuelType);
        setFormData((prevState) => ({
          ...prevState,
          fuelType: response.data.data?.fuelType,
        }));
      })
      .catch((err) => console.log("err", err));
  };

  useEffect(() => {
    if (id && data) {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles(data?.documents || []);
    } else if (!id) {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles([]);
    }
  }, [data, id]);

  const handleChange = (e) => {
    console.log("hii fr testing");
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    console.log("handleChangeForField", name, value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

    setFormData((prevState) => ({
      ...prevState,
      ...(sub
        ? {
            [main]: {
              ...prevState[main], // Preserve existing properties inside `main`
              [sub]: value,
            },
          }
        : { [name]: value }),
    }));
    if (name === "machineryType") {
      fetchFuelType();
    }
  };

  const handleClose = () => {
    // const isFormDataUnchanged = Object.keys(formData).every(
    //   (key) => formData[key] === formData2[key]
    // );
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];

      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    console.log(
      isFormDataUnchanged,
      formData2,
      formData,
      "isFormDataUnchanged"
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      // setAddData(false);
      // setErrors({});
      setEditDialog(true);
      // resetForm();
      // Show the EditDialog if there are changes
    }
    // setFormData(initialState); // Reset form data to initial state
    // setUploadedFiles([]); // Reset uploaded files
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (!validateNumber(month)) newErrors["month"] = "Month is required";

        if (!validateNumber(year)) newErrors["year"] = "Year is required";

        return;
      }
      console.log(formData, value, "formData[input.fieldName]");

      if (input.type === "number") {
        const check = typeof value === "object" ? value.value : value;
        console.log(value, "value for the Check");
        if (!validateNumber(check)) {
          console.log(value, "value for the Check");

          // Initialize the field in newErrors if it doesn't exist
          if (!newErrors[input.fieldName]) {
            newErrors[input.fieldName] = {}; // Ensure it's an object
          }

          newErrors[input.fieldName].value = numberError; // Assign the error
          return; // Stop further checks for this input
        }
      }
      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    console.log(newErrors, "check input errors");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      quantityReleased: {
        value: Number(formData.quantityReleased?.value),
        unit: "kg",
      },
    };

    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;

    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData({});
        setAddData(false);
        setErrors({});
        // resetForm();
        resetForm();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    console.log(
      "elForRenderInput",
      el.url,
      el.fieldName,
      formData,
      formData[el.fieldName]
    );
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={"name"}
          //   keyName={"name"}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }
    if (el.fieldName === "quantityReleased") {
      return (
        // <InputField sx={{width:"15%"}}
        //   title={formatTitleWithOptional(el.title)}
        //   handleChange={handleChange}
        //   placeholder={el.placeholder}
        //   // value={formData[el.fieldName] || ""}
        //   value={typeof formData[el.fieldName]=== "object" ? formData[el.fieldName]?.value : formData[el.fieldName]}
        //   errors={errors[el.fieldName]}
        //   fieldName={el.fieldName}

        // />
        <InputField
          sx={{ width: "15%" }}
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={
            typeof formData[el.fieldName] === "object"
              ? formData[el.fieldName]?.value
              : formData[el.fieldName]
          }
          errors={errors[el.fieldName]}
          // fieldName={el.fieldName}
          fieldName={`${el.fieldName}.value`}
          adornmentText="Kg"
        />
      );
    }
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Period"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        // value={formData[el.fieldName] || ""}
        value={
          typeof formData[el.fieldName] === "object"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName]
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
      />
    );
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26.5rem", maxWidth: "100%", height: "100vh" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ width: "100%", p: 3, backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Fire Extinguisher" : "Add Fire Extinguisher"}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "30%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddFireExitingul;

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));
